import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPage } from "@/pages/legal/PrivacyPage";
import { localizedHead } from "@/lib/seo";

export const Route = createFileRoute("/en/privacy")({
  head: () => {
    const lh = localizedHead({ path: "/privacy", locale: "en" });
    return {
      meta: [
        { title: "Privacy Policy — Farveladeland" },
        {
          name: "description",
          content: "How Farveladeland handles your personal data.",
        },
        { property: "og:title", content: "Privacy Policy — Farveladeland" },
        {
          property: "og:description",
          content: "How Farveladeland handles your personal data.",
        },
        ...lh.meta,
      ],
      links: lh.links,
    };
  },
  component: PrivacyPage,
});
